import type { ReactElement } from 'react';

import {
  AvatarFallback,
  Avatar as AvatarPrimitive,
} from 'src/components/ui/avatar';
import { cn } from 'src/lib/utils';
import colorService from 'src/services/colors/colorService';

type AvatarProps = {
  firstname: string;
  lastname?: string;
  className?: string;
};

export function Avatar({
  firstname,
  lastname = '',
  className,
}: AvatarProps): ReactElement {
  const { getColorFromString } = colorService;
  const color = getColorFromString(`${firstname}${lastname}`, 50, 45);

  return (
    <AvatarPrimitive className={cn('rounded-full', className)}>
      <AvatarFallback
        className={cn('rounded-full', className)}
        hslColor={color}
      >
        {firstname.split('').shift()}
        {lastname.split('').shift()}
      </AvatarFallback>
    </AvatarPrimitive>
  );
}
